<template>
    <div class="animated fadeIn">
        <b-row v-if="loading">
            <b-col cols="12" md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
        <b-row v-if="!loading">
            <b-col cols="12" md="12">
                <ComponentNewHeader
                    title="Item Details"
                    :hasSearch="false"
                    :hasCreate="false"
                    :hasReload="false"
                    :hasback="true"
                    @back-press="backNavigate"
                />
            </b-col>
            <b-col cols="12" sm="12">
                <b-card>
                    <div>
                        <b-card>
                            <b-row class="ml-md-5">
                                <b-col cols="12" sm="12" md="4">
                                    <b-form-group
                                        label="Icon Image"
                                        label-for="SmallImage"
                                        :label-cols="7"
                                        :horizontal="true"
                                    ></b-form-group>
                                    <div class="image-container">
                                        <img
                                            :src="
                                                iconImagedata ||
                                                itemObj.product_summary.images
                                                    .icon
                                            "
                                            @error="
                                                onImageError(
                                                    $event,
                                                    itemObj.product_summary
                                                        .images.icon,
                                                )
                                            "
                                            class="image-size"
                                        />
                                    </div>
                                </b-col>
                                <b-col cols="12" sm="12" md="4">
                                    <b-form-group
                                        label="Small Image"
                                        label-for="SmallImage"
                                        :label-cols="7"
                                        :horizontal="true"
                                    ></b-form-group>
                                    <div class="item-image-container">
                                        <img
                                            :src="
                                                smallImagedata ||
                                                itemObj.product_summary.images
                                                    .smallImage
                                            "
                                            @error="
                                                onImageError(
                                                    $event,
                                                    itemObj.product_summary
                                                        .images.smallImage,
                                                )
                                            "
                                            class="item-image"
                                        />
                                    </div>
                                </b-col>
                                <b-col cols="12" sm="12" md="4">
                                    <b-form-group
                                        label="Big Image"
                                        label-for="BigImage"
                                        :label-cols="7"
                                        :horizontal="true"
                                    ></b-form-group>
                                    <div class="item-image-container">
                                        <img
                                            :src="
                                                landingImagedata ||
                                                itemObj.product_summary.images
                                                    .bigImage
                                            "
                                            @error="
                                                onImageError(
                                                    $event,
                                                    itemObj.product_summary
                                                        .images.bigImage,
                                                )
                                            "
                                            class="item-image"
                                        />
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                    <div
                        v-for="(entry, idx) in attributesMap.entries()"
                        :key="idx"
                    >
                        <b-row>
                            <b-col
                                v-for="(item, index) in entry[1]"
                                :key="index"
                                :cols="['Array'].includes(item.type) ? 12 : 12"
                                :sm="['Array'].includes(item.type) ? 12 : 12"
                                :md="['Array'].includes(item.type) ? 12 : 6"
                                :class="{
                                    'd-none':
                                        item.type === 'Array' &&
                                        (!valuesMap[item.name] ||
                                            !valuesMap[item.name][0]),
                                }"
                            >
                                <field
                                    v-if="item.name !== 'b2bType'"
                                    :fieldType="item.type"
                                    :fieldName="item.name"
                                    :displayName="
                                        item.attributeLabel &&
                                        item.attributeLabel[tenantLang]
                                            ? item.attributeLabel[tenantLang]
                                            : item.name
                                    "
                                    :onChange="fieldChange"
                                    :value="valuesMap[item.name]"
                                    :id="item._id"
                                    :isRequired="item.isRequired"
                                    :subFields="item.attributeItems"
                                    :level="0"
                                    :meta="[
                                        { name: item.name, type: item.type },
                                    ]"
                                    :active="activeIndex"
                                    :index="index"
                                    :setActive="setActive"
                                    :UIConcern="item.UIConcern"
                                    :enumValues="item.enumValues"
                                    :arrayChange="arrayChange"
                                    :valuesMap="valuesMap"
                                    :disabled="true"
                                    :visibility="
                                        item.visibility
                                            ? item.visibility.onShow
                                            : true
                                    "
                                />
                                <card v-if="item.name === 'b2bType'">
                                    <label class="card-title">{{
                                        item.name
                                    }}</label>
                                    <b-col class="pb-1">
                                        <eb-select
                                            type="text"
                                            :id="'b2bType'"
                                            v-model="typeB2b"
                                            :options="selectB2b"
                                            :selected="typeB2b"
                                            label="text"
                                            placeholder="Select b2b Type"
                                        ></eb-select>
                                    </b-col>
                                </card>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-if="isAddresscapture">
                        <b-row>
                            <b-col>
                                <Card>
                                    <div class="wrap">
                                        <b-form-group>
                                            <p class="head">Location</p>
                                            <b-form-input
                                                :value="
                                                    itemObj.Address
                                                        ? itemObj.Address
                                                              .Address
                                                        : ''
                                                "
                                                :disabled="true"
                                            ></b-form-input>
                                        </b-form-group>
                                    </div>
                                </Card>
                            </b-col>
                        </b-row>
                    </div>
                    <div>
                        <a-divider />
                        <div
                            v-if="
                                itemObj &&
                                itemObj.variations &&
                                itemObj.variations.length
                            "
                        >
                            <h3>Variations</h3>
                            <b-row
                                v-for="(va, i) in itemObj.variations"
                                :key="i"
                            >
                                <b-col
                                    md="2"
                                    v-for="(f, j) in Object.keys(va.attributes)"
                                    :key="j"
                                >
                                    {{ f }}: {{ va.attributes[f] }}
                                </b-col>
                                <b-col md="2"> Price: {{ va.Price }} </b-col>
                                <b-col md="2">
                                    Discount: {{ va.Discount }}
                                </b-col>
                                <b-col md="3">
                                    Discount Percentage:
                                    {{ va.DiscountPercentage }}
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<style scoped>
.flex-row {
    display: flex;
}
</style>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import cTable from "@/views/base/Table.vue";
import Field from "@/components/Item/Field";
import Card from "@/components/Generics/Card.vue";
import SingleImage from "@/components/Common/Image.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import VueUploadMultipleImage from "@/components/FormElements/VueUploadMultipleImage";
import locationMixins from "@/mixins/addressLocation";
import locationaddress from "@/components/LocationElement/addressAutocomplete";
import { BUCKET_BASEURL, GATEWAY_BASEURL } from "@/services/index";
import { mapGetters } from "vuex";
import Variance from "@/components/Variance/Variance.vue";
import ComponentNewHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
    name: "viewItem",
    dark: {
        type: Boolean,
        default: false,
    },
    components: {
        cSwitch,
        cTable,
        Card,
        field: Field,
        SingleImage,
        locationaddress,
        ebSelect,
        VueUploadMultipleImage,
        Variance,
        ComponentNewHeader,
        AtomSpinner,
    },
    data() {
        return {
            typeB2b: {},
            itemObj: {
                product_summary: {
                    images: {
                        icon: "",
                        smallImage: "",
                        bigImage: "",
                    },
                },
                Address: {},
                attributeItems: [],
                string_attributes: [],
                integer_attributes: [],
                variations: [],
            },
            iconImagedata: null,
            smallImagedata: null,
            landingImagedata: null,
            alternateImages: [],
            inputObj: {
                Name: "",
                description_summary: "",
                provider: null,
                catalogId: "",
                images: {
                    icon: "",
                    smallImage: "",
                    bigImage: "",
                    alternateImages: [],
                },
            },
            externalAttribute: [],
            attributesMap: new Map(),
            valuesMap: {},
            activeIndex: null,
            submitted: false,
            location: {
                address: "",
                data: {},
                lat: "",
                lng: "",
            },
            isAddresscapture: false,
            loading: false,
        };
    },
    computed: {
        ...mapGetters({
            tenantLang: "tenant/GetTenantLanguage",
            partnerAllData: "partner/GetPartnerData",
        }),
        userRole() {
            if (this.$store.getters["auth/getUserRole"]) {
                return this.$store.getters["auth/getUserRole"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
            }
        },
        selectB2b() {
            return [
                {
                    text: "Sell to Customer",
                    value: 0,
                },
                {
                    text: "Sell to Merchant",
                    value: 1,
                },
                {
                    text: "Sell to Both",
                    value: 2,
                },
            ];
        },
    },
    props: {
        context: {
            type: String,
        },
    },
    mixins: [locationMixins],
    methods: {
        getDefaultItemObject() {
            return {
                product_summary: {
                    images: {
                        icon: "",
                        smallImage: "",
                        bigImage: "",
                    },
                },
                Address: {},
                attributeItems: [],
                string_attributes: [],
                integer_attributes: [],
                variations: [],
                b2bType: 0,
            };
        },
        async fetchImages() {
            if (!this.itemObj || !this.itemObj.product_summary) return;
            this.iconImagedata = await this.getImageUrl(
                this.itemObj.product_summary.images.icon,
            );
            this.smallImagedata = await this.getImageUrl(
                this.itemObj.product_summary.images.smallImage,
            );
            this.landingImagedata = await this.getImageUrl(
                this.itemObj.product_summary.images.bigImage,
            );
        },
        backNavigate() {
            if (this.userRole === "Tenant") {
                this.$router.push({
                    name: "partner-item",
                    params: { id: this.partnerAllData._id },
                });
            } else {
                this.$router.push("/item");
            }
        },
        getImageKeyfromURL(imageURL) {
            if (!imageURL || typeof imageURL !== "string") return "";
            if (imageURL.startsWith("http://") || imageURL.startsWith("https://")) {
                try {
                    const parsedURL = new URL(imageURL);
                    return parsedURL.pathname.replace(/^\/+/, "");
                } catch (error) {
                    return "";
                }
            }
            return imageURL.replace(BUCKET_BASEURL, "").replace(/^\/+/, "");
        },
        async getImageUrl(imageURL) {
            if (!imageURL) return "";
            const imageKey = await this.getImageKeyfromURL(imageURL);
            if (!imageKey) return "";
            return `${GATEWAY_BASEURL}/resize/index.php?width=300&height=250&quality=100&name=${encodeURIComponent(imageKey)}`;
        },
        onImageError(event, fallbackURL) {
            if (!event || !event.target) return;
            const target = event.target;
            if (target.dataset && target.dataset.fallbackApplied === "true") {
                return;
            }
            if (fallbackURL) {
                if (target.dataset) {
                    target.dataset.fallbackApplied = "true";
                }
                target.src = fallbackURL;
            }
        },
        fieldChange(data) {
            if (data.meta[0].name === "Name") {
                this.inputObj.Name = data.value;
                this.inputObj.description_summary = data.value;
            } else {
                if (
                    data.meta[0].type === "String" &&
                    data.meta[0].name !== "Title"
                ) {
                    this.inputObj[data.meta[0].name] = data.value;
                } else if (data.meta[0].type === "Number") {
                    this.inputObj[data.meta[0].name] = data.value;
                }
            }
        },
        setActive(i) {
            this.activeIndex = this.activeIndex == i ? -1 : i;
        },
        arrayChange(data) {
            let { index, type, e, fieldName } = data;
            let { meta, value, action, arrObj } = data;
            let updateDoc = { ...this.valuesMap };
            let temp = this.valuesMap;
            let parent = temp;
            let path = "";
            for (let i = 0; i < meta.length; i++) {
                let item = meta[i],
                    { type, name } = item;
                if (["Object", "String", "Number", "Array"].includes(type)) {
                    parent = temp;
                    path = item.name;
                    temp = temp[item.name];
                }
            }
            let name = index;
            switch (type) {
                case "check": {
                    this.$set(temp[index], "checked", e.target.checked);
                    break;
                }
                case "select": {
                    this.$set(parent, fieldName, e);
                    break;
                }
                case "radio": {
                    this.$set(parent, fieldName, e);
                }
            }
            if (arrObj === true) {
                switch (action) {
                    case "change": {
                        this.$set(
                            parent,
                            path,
                            temp.map((item, idx) =>
                                idx === index
                                    ? {
                                          ...item,
                                          [fieldName]: e,
                                      }
                                    : item,
                            ),
                        );
                        break;
                    }
                    case "add": {
                        let tObj = {};
                        let keys = Object.keys(temp[0]);
                        for (let i = 0; i < keys.length; i++) {
                            tObj[keys[i]] = "";
                        }
                        this.$set(parent, path, temp.concat([tObj]));
                    }
                    case "remove": {
                        temp.splice(index, 1);
                    }
                }
            }
        },
    },
    mounted: async function () {
        let userID = this.$store.getters["auth/getUserID"];
        this.inputObj.provider = userID;
        await this.$store.dispatch("item/fetchItemById", this.$route.params.id);
        let data = this.$store.getters["item/GetCurrentItemObject"];
        const responsePayload = data && data.response;
        let result =
            responsePayload && Array.isArray(responsePayload)
                ? responsePayload[0] || null
                : responsePayload && typeof responsePayload === "object"
                  ? responsePayload
                  : null;
        this.itemObj = result
            ? {
                  ...this.getDefaultItemObject(),
                  ...result,
                  product_summary: {
                      ...this.getDefaultItemObject().product_summary,
                      ...(result.product_summary || {}),
                      images: {
                          ...this.getDefaultItemObject().product_summary.images,
                          ...((result.product_summary || {}).images || {}),
                      },
                  },
              }
            : this.getDefaultItemObject();
        this.typeB2b = this.selectB2b.filter((sellTo) => {
            return sellTo.value == this.itemObj?.b2bType;
        });
        await this.fetchImages();
        let typeSet = new Set(["String", "Number", "Object", "Array"]);
        let attributesMap = new Map([
            ["String", []],
            ["Number", []],
            ["Object", []],
            ["Array", []],
        ]);
        let valuesMap = { ...this.itemObj };
        const attributeItems = Array.isArray(this.itemObj.attributeItems)
            ? this.itemObj.attributeItems
            : [];
        attributeItems.forEach((item) => {
            if (
                item &&
                item.attributeName !== "Address" &&
                item.attributeName !== "State" &&
                item.attributeName !== "Country" &&
                item.attributeName !== "City" &&
                item.attributeName !== "Area" &&
                item.attributeName !== "Lat" &&
                item.attributeName !== "Lng"
            ) {
                let type = item.attributeValueType,
                    name = item.attributeName;
                // check key value is allowed type
                if (typeSet.has(type)) {
                    let attObj = {
                        ...item,
                        type,
                        name,
                    };
                    attributesMap.set(
                        type,
                        attributesMap.get(type).concat([attObj]),
                    );
                    if (type == "Array") {
                        if (attObj.UIConcern === "Select") {
                            const attributeOptions = Array.isArray(
                                attObj.attributeItems,
                            )
                                ? attObj.attributeItems
                                : [];
                            let options = new Map(
                                attributeOptions
                                    .filter((a) => a && (a._id || a.id))
                                    .map((a) => {
                                        const optionId = a._id || a.id;
                                        return [
                                            optionId,
                                            {
                                                label: a.attributeName,
                                                value: optionId,
                                            },
                                        ];
                                    }),
                            );
                            const existingSelection = Array.isArray(
                                valuesMap[name],
                            )
                                ? valuesMap[name]
                                : [];
                            valuesMap[name] = existingSelection
                                .map((o) => options.get(o))
                                .filter(Boolean);
                        }
                        if (attObj.UIConcern === "Object") {
                            valuesMap[name] = valuesMap[name];
                        }
                        if (attObj.UIConcern === "Checkbox") {
                            valuesMap[name] = valuesMap[name];
                        }
                    }
                    if (["Number", "String"].includes(type)) {
                        const addresses = {
                            Number: "integer_attributes",
                            String: "string_attributes",
                        };
                        const attributes = Array.isArray(
                            this.itemObj[addresses[type]],
                        )
                            ? this.itemObj[addresses[type]]
                            : [];
                        const valueItem = attributes.find(
                            (pair) => pair.attribute_name == name,
                        );
                        if (valueItem) {
                            valuesMap[name] = valueItem.attribute_value;
                        }
                    }
                }
            } else if (item && item.attributeName === "Address") {
                this.isAddresscapture = true;
            }
        });
        this.attributesMap = attributesMap;
        this.valuesMap = valuesMap;
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.card-wrap {
    border: none !important;
    box-shadow: 0px 0px 10px 1px rgb(235, 235, 235) !important;
    border-radius: 1px !important;
}

.card-title {
    font-size: 1em;
    font-weight: 800;
    padding-left: 14px;
}

.image-container {
    height: 200px;
    width: 180px;
}

.image-size {
    height: 200px;
    width: 180px;
    object-fit: contain;
}

.item-image-container {
    height: 200px;
    width: 180px;
}

.item-image {
    height: 200px;
    width: 180px;
    object-fit: contain;
}
</style>
